import { defineStore } from "pinia";

import communicationService from "@/services/modules/communication";

import type { SmsMessageEventData } from "@/models/communicationLogs";
import type { SmsModalData } from "@/models/sms";

interface UseSmsState {
  modalData: SmsModalData;
  incomingSmsEvents: SmsMessageEventData[];
  incomingSmsEventData: SmsMessageEventData | null;
  activeSmsConversation: SmsMessageEventData | null;
}

const getDefaultState = (): UseSmsState => ({
  modalData: {
    applications: [],
    from_number: "",
    templates: [],
  },
  incomingSmsEvents: [],
  incomingSmsEventData: null,
  activeSmsConversation: null,
});

const useSmsStore = defineStore("sms", {
  state: getDefaultState,
  actions: {
    async getApplicationSmsModalData(application_ids: string[]) {
      const data =
        await communicationService.getApplicationSmsModalData(application_ids);
      this.modalData = data;
    },
  },
});

export default useSmsStore;
